import { render, staticRenderFns } from "./BrainstormCollect.vue?vue&type=template&id=568a9c66&scoped=true&"
import script from "./BrainstormCollect.vue?vue&type=script&lang=js&"
export * from "./BrainstormCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568a9c66",
  null
  
)

export default component.exports